module.exports = __webpack_public_path__ + "static/media/alert-yellow.793fcb17.svg";